<script>
  import { hsl } from 'd3-color';
import {
scaleLinear,


scaleThreshold
} from 'd3-scale';

  const colorScale = scaleThreshold()
    .domain([0.5, 0.6]) // 60%+ is roughly 85th percentil, 50% is roughly 54th percentile
    .range(['#2d3467', '#3c9245', '#f9ce1a'])
    .range(['#0d478a', '#1c9a8b', '#f9ce1a'])
    .range(['#0d478a', '#9e8667', '#f9ce1a'])
    .range(['#992B3D', '#0d478a', '#24C79E'])
    .range(['#cc002f', '#df7f45', '#eecb61'])
    .range(['#912d2c', '#d88130', '#fbe254'])
    .range(['#edf8b1', '#7fcdbb', '#2c7fb8'])
    .range(['#fff58d', '#5bb68f', '#00649f'].reverse())

  const blockHeight = 4;

  const blocks = [
    {color: colorScale.range()[0], label: '< 50%' },
    {color: colorScale.range()[1], label: '50–60%' },
    {color: colorScale.range()[2], label: '60%+' },
  ]

  </script>

<style>
  
  .blocks {
    display: flex;
  }
  .block {
    flex: 1;
    margin-right: 2px;
  }
  .block:last-child {
    margin-right: 0;
  }
</style>


  <div class="legend">
    <div><span class="header">Career Win % </span><span class="secondary">Prior to 2019-20</span></div>
    <div class="blocks">
      {#each blocks as block}
      <div class="block">
        <div style="height: {blockHeight}px; background-color: {block.color};"></div>
        <div>{block.label}</div>
      </div>
      {/each}
    </div>
    
  </div>